/*
  Header dropdown behaviour for the desktop inline menu.

  Two changes on top of the native <details> disclosure:

  1. The parent item is a real <a>, so it can be clicked through to its index
     page. Its click is stopped from reaching the <summary>, which would
     otherwise toggle the panel open on the way out of the page.
  2. On pointer devices the panel opens on hover. The caret still toggles it,
     which is what touch and keyboard users get, since neither has a hover.

  Driving details.open (rather than styling the panel directly) keeps Dawn's
  existing CSS, open animation and HeaderMenu sticky-header logic working, as
  all of it is keyed to the [open] attribute.
*/
(function () {
  var CLOSE_DELAY = 200;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var menus = [];

  function setExpanded(entry, expanded) {
    entry.details.open = expanded;
    entry.summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function open(entry) {
    clearTimeout(entry.timer);
    // Only ever one panel at a time, so moving along the bar doesn't stack them.
    menus.forEach(function (other) {
      if (other !== entry && other.details.open) {
        clearTimeout(other.timer);
        setExpanded(other, false);
      }
    });
    if (!entry.details.open) setExpanded(entry, true);
  }

  function closeSoon(entry) {
    clearTimeout(entry.timer);
    entry.timer = setTimeout(function () {
      // Don't snatch the panel away from someone tabbing through it.
      if (!entry.root.contains(document.activeElement)) setExpanded(entry, false);
    }, CLOSE_DELAY);
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (root) {
    var details = root.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    var entry = { root: root, details: details, summary: summary, timer: null };
    menus.push(entry);

    var parentLink = summary.querySelector('.header__menu-parent-link');
    if (parentLink) {
      parentLink.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    root.addEventListener('mouseenter', function () {
      if (canHover.matches) open(entry);
    });

    root.addEventListener('mouseleave', function () {
      if (canHover.matches) closeSoon(entry);
    });

    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) {
        setExpanded(entry, false);
        summary.focus();
      }
    });
  });
})();
